import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useModal } from '../../contexts/ModalContext'
import ActivityLog from '../../model/ActivityLog'
import { dataSource } from '../../service/domain/_service.config'
import ListUtil from '../../util/ListUtil'
import { useChallengeAccess } from '../membership/useChallengeAccess'
import { optimisticUpdate } from '../util/optimisticUpdate'
import { ACTIVITY_LOGS_QUERY_KEY } from './useActivityLogs'

export function useDeleteActivityLog(teamID?: string) {
  const { showSnackbar } = useModal()
  const { teamID: activeTeamID } = useChallengeAccess()
  const resolvedTeamID = teamID || activeTeamID
  const queryClient = useQueryClient()
  const optimistic = optimisticUpdate<ActivityLog[], string>(
    queryClient,
    ACTIVITY_LOGS_QUERY_KEY(resolvedTeamID ?? ''),
    (current, activityLogID) => ListUtil.remove(current, (log) => log.id === activityLogID),
  )

  return useMutation({
    mutationFn: (activityLogID: string) => dataSource.deleteActivityLog(activityLogID),
    ...optimistic,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['leaderboard'] }),
    onError: (error, activityLogID, context) => {
      optimistic.onError(error, activityLogID, context)
      showSnackbar('delete', 'Failed to delete activity log', 'error')
    },
  })
}
